module.exports = __webpack_public_path__ + "static/img/home_buffer_photo5@2x.9ea31ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productCase/home_buffer_photo5@2x.png
// module id = kDKI
// module chunks = 0